import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import DetailsPageHeader from "../../../components/shared/DetailsPageHeader";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";

import { useBeManualFetcher } from "../../../hooks/useBeManualFetcher";
import { useSummerSchoolSparkContext } from "../../../hooks/useSummerSchoolSparkContext";
import { Card } from "reactstrap";
import { Block, BlockBetween, BlockTitle } from "../../../components/Component";
import UpdatableText from "../../../components/shared/UpdatabaleText";
import { summerSchoolSparkService } from "../../../services/summerSchoolSparkService";

const SummerSchoolSparkDetails = () => {
  const { id } = useParams();
  const { applicant, setApplicant } = useSummerSchoolSparkContext();
  const [onFetch, isLoading] = useBeManualFetcher();

  async function handleStudentDataFetch() {
    await onFetch({
      action: () => summerSchoolSparkService.getSummerSchoolSparkById(id),
      onLoad: (response) => setApplicant(response),
    });
  }

  useEffect(() => {
    handleStudentDataFetch();
  }, [id]);

  return (
    <>
      <Head title="Participant Details" />
      <Content>
        <DetailsPageHeader
          title={"Participant -"}
          name={applicant?.fullName}
          createdDate={applicant?.createdAt}
          goBackPath={"/summer-science-spark"}
          isLoading={isLoading.id}
        />
        <Card className="card-inner">
          <Block>
            <form>
              <BlockBetween className="mb-3">
                <BlockTitle tag="h5">Personal Information</BlockTitle>
              </BlockBetween>
              <div className="profile-ud-list">
                <div className="profile-ud-item position-relative">
                  <UpdatableText
                    title="Full Name"
                    defaultValue={applicant?.fullName}
                    name={"firstName"}
                    isWider
                  />
                  <UpdatableText
                    title="Phone Number"
                    defaultValue={applicant?.phoneNumber}
                    name={"phoneNumber"}
                    isWider
                  />
                  <UpdatableText
                    title="Secondary Phone Number"
                    defaultValue={applicant?.secondPhoneNumber}
                    name={"secondaryPhoneNumber"}
                    isWider
                  />
                  <UpdatableText
                    title="Email Address"
                    defaultValue={applicant?.email}
                    name={"email"}
                    isWider
                  />
                  <UpdatableText
                    title="Social Media Permission"
                    defaultValue={
                      applicant?.socialMediaPermission ? "Yes" : "No"
                    }
                    name={"socialMediaPermission"}
                    isWider
                  />
                </div>
                <div className="profile-ud-item">
                  <UpdatableText
                    title="Region"
                    defaultValue={applicant?.region}
                    name={"region"}
                    isWider
                  />
                  <UpdatableText
                    title="District / City"
                    defaultValue={applicant?.city}
                    name={"city"}
                    isWider
                  />
                  <UpdatableText
                    title="School/Academic Lyceum"
                    defaultValue={applicant?.school}
                    name={"school"}
                    isWider
                  />
                  <UpdatableText
                    title="Year of Study"
                    defaultValue={applicant?.grade}
                    name={"grade"}
                    isWider
                  />
                  <UpdatableText
                    title="IELTS Score"
                    defaultValue={applicant?.ieltsScore ?? "-"}
                    name={"ieltsScore"}
                    isWider
                  />
                </div>
              </div>
            </form>
          </Block>
        </Card>
      </Content>
    </>
  );
};

export default SummerSchoolSparkDetails;
